"use client";

import dynamic from "next/dynamic";
import type { ComponentProps } from "react";
import type VirtualSpacePublicRendererType from "@/components/virtualspace/virtual-space-public-renderer";
import { ViewerSkeleton } from "@/components/virtualspace/viewer-skeleton";

const VirtualSpacePublicRenderer = dynamic(
  () => import("@/components/virtualspace/virtual-space-public-renderer"),
  {
    loading: () => (
      <ViewerSkeleton
        height="min(50dvh, 480px)"
        label="Loading experience…"
      />
    ),
  },
);

type Props = ComponentProps<typeof VirtualSpacePublicRendererType>;

/**
 * Code-splits the ~5.8k-line public VirtualSpace renderer so share
 * / tier routes paint theme chrome before the block bundle downloads.
 */
export default function VirtualSpacePublicRendererLazy(props: Props) {
  return <VirtualSpacePublicRenderer {...props} />;
}
